import {
  hm5LimitedReleaseDetailConstants,
  createHM5LimitedReleaseDetailConstants,
  editHM5LimitedReleaseDetailConstants,
  addTargetHM5LimitedReleaseDetailConstants,
  removeTargetHM5LimitedReleaseDetailConstants,
  activateHM5LimitedReleaseDetailConstants,
  deactivateHM5LimitedReleaseDetailConstants,
  deleteHM5LimitedReleaseDetailConstants,
} from "../_redux-constants";

export function hm5LimitedReleasesDetailReducer(
  state = {
    hm5LimitedReleaseDetailLoading: false,
    hm5LimitedReleaseDetailData: null,
    hm5LimitedReleaseDetailError: null,

    createHM5LimitedReleaseDetailLoading: false,
    createHM5LimitedReleaseDetailData: null,
    createHM5LimitedReleaseDetailError: null,

    editHM5LimitedReleaseDetailLoading: false,
    editHM5LimitedReleaseDetailData: null,
    editHM5LimitedReleaseDetailError: null,

    addTargetHM5LimitedReleaseDetailLoading: false,
    addTargetHM5LimitedReleaseDetailData: null,
    addTargetHM5LimitedReleaseDetailError: null,

    removeTargetHM5LimitedReleaseDetailLoading: false,
    removeTargetHM5LimitedReleaseDetailData: null,
    removeTargetHM5LimitedReleaseDetailError: null,

    activateHM5LimitedReleaseDetailLoading: false,
    activateHM5LimitedReleaseDetailData: null,
    activateHM5LimitedReleaseDetailError: null,

    deactivateHM5LimitedReleaseDetailLoading: false,
    deactivateHM5LimitedReleaseDetailData: null,
    deactivateHM5LimitedReleaseDetailError: null,

    deleteHM5LimitedReleaseDetailLoading: false,
    deleteHM5LimitedReleaseDetailData: null,
    deleteHM5LimitedReleaseDetailError: null,
  },
  action
) {
  switch (action.type) {
    case hm5LimitedReleaseDetailConstants.HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        hm5LimitedReleaseDetailLoading: true,
        hm5LimitedReleaseDetailData: null,
        hm5LimitedReleaseDetailError: null,
      });
    case hm5LimitedReleaseDetailConstants.HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        hm5LimitedReleaseDetailLoading: false,
        hm5LimitedReleaseDetailData: action.data,
      });
    case hm5LimitedReleaseDetailConstants.HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        hm5LimitedReleaseDetailLoading: false,
        hm5LimitedReleaseDetailData: null,
        hm5LimitedReleaseDetailError: action.error,
      });
    case createHM5LimitedReleaseDetailConstants.CREATE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        createHM5LimitedReleaseDetailLoading: true,
        createHM5LimitedReleaseDetailData: null,
        createHM5LimitedReleaseDetailError: null,
      });
    case createHM5LimitedReleaseDetailConstants.CREATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        createHM5LimitedReleaseDetailLoading: false,
        createHM5LimitedReleaseDetailData: action.data,
      });
    case createHM5LimitedReleaseDetailConstants.CREATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        createHM5LimitedReleaseDetailLoading: false,
        createHM5LimitedReleaseDetailData: null,
        createHM5LimitedReleaseDetailError: action.error,
      });
    case editHM5LimitedReleaseDetailConstants.EDIT_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        editHM5LimitedReleaseDetailLoading: true,
        editHM5LimitedReleaseDetailData: null,
        editHM5LimitedReleaseDetailError: null,
      });
    case editHM5LimitedReleaseDetailConstants.EDIT_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        editHM5LimitedReleaseDetailLoading: false,
        editHM5LimitedReleaseDetailData: action.data,
      });
    case editHM5LimitedReleaseDetailConstants.EDIT_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        editHM5LimitedReleaseDetailLoading: false,
        editHM5LimitedReleaseDetailData: null,
        editHM5LimitedReleaseDetailError: action.error,
      });
    case addTargetHM5LimitedReleaseDetailConstants.ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        addTargetHM5LimitedReleaseDetailLoading: true,
        addTargetHM5LimitedReleaseDetailData: null,
        addTargetHM5LimitedReleaseDetailError: null,
      });
    case addTargetHM5LimitedReleaseDetailConstants.ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        addTargetHM5LimitedReleaseDetailLoading: false,
        addTargetHM5LimitedReleaseDetailData: action.data,
      });
    case addTargetHM5LimitedReleaseDetailConstants.ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        addTargetHM5LimitedReleaseDetailLoading: false,
        addTargetHM5LimitedReleaseDetailData: null,
        addTargetHM5LimitedReleaseDetailError: action.error,
      });
    case removeTargetHM5LimitedReleaseDetailConstants.REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        removeTargetHM5LimitedReleaseDetailLoading: true,
        removeTargetHM5LimitedReleaseDetailData: null,
        removeTargetHM5LimitedReleaseDetailError: null,
      });
    case removeTargetHM5LimitedReleaseDetailConstants.REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        removeTargetHM5LimitedReleaseDetailLoading: false,
        removeTargetHM5LimitedReleaseDetailData: action.data,
      });
    case removeTargetHM5LimitedReleaseDetailConstants.REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        removeTargetHM5LimitedReleaseDetailLoading: false,
        removeTargetHM5LimitedReleaseDetailData: null,
        removeTargetHM5LimitedReleaseDetailError: action.error,
      });
    case activateHM5LimitedReleaseDetailConstants.ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        activateHM5LimitedReleaseDetailLoading: true,
        activateHM5LimitedReleaseDetailData: null,
        activateHM5LimitedReleaseDetailError: null,
      });
    case activateHM5LimitedReleaseDetailConstants.ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        activateHM5LimitedReleaseDetailLoading: false,
        activateHM5LimitedReleaseDetailData: action.data,
      });
    case activateHM5LimitedReleaseDetailConstants.ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        activateHM5LimitedReleaseDetailLoading: false,
        activateHM5LimitedReleaseDetailData: null,
        activateHM5LimitedReleaseDetailError: action.error,
      });
    case deactivateHM5LimitedReleaseDetailConstants.DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deactivateHM5LimitedReleaseDetailLoading: true,
        deactivateHM5LimitedReleaseDetailData: null,
        deactivateHM5LimitedReleaseDetailError: null,
      });
    case deactivateHM5LimitedReleaseDetailConstants.DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deactivateHM5LimitedReleaseDetailLoading: false,
        deactivateHM5LimitedReleaseDetailData: action.data,
      });
    case deactivateHM5LimitedReleaseDetailConstants.DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deactivateHM5LimitedReleaseDetailLoading: false,
        deactivateHM5LimitedReleaseDetailData: null,
        deactivateHM5LimitedReleaseDetailError: action.error,
      });
    case deleteHM5LimitedReleaseDetailConstants.DELETE_HM5_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deleteHM5LimitedReleaseDetailLoading: true,
        deleteHM5LimitedReleaseDetailData: null,
        deleteHM5LimitedReleaseDetailError: null,
      });
    case deleteHM5LimitedReleaseDetailConstants.DELETE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deleteHM5LimitedReleaseDetailLoading: false,
        deleteHM5LimitedReleaseDetailData: action.data,
      });
    case deleteHM5LimitedReleaseDetailConstants.DELETE_HM5_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deleteHM5LimitedReleaseDetailLoading: false,
        deleteHM5LimitedReleaseDetailData: null,
        deleteHM5LimitedReleaseDetailError: action.error,
      });
    default:
      return state;
  }
}
